import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [{
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true
  },
  {
    path: '',
    component: Layout,
    redirect: '/home',
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: {
        title: '首页',
        icon: 'home'
      }
    }]
  }
]

export const asyncRouterMap = [


  {
    path: '/mms',
    component: Layout,
    redirect: '/mms/user',
    name: 'mms',
    meta: {
      title: '用户管理',
      icon: 'ums'
    },
    children: [{
      path: 'user',
      name: 'user',
      component: () => import('@/views/mms/user/index'),
      meta: {
        title: '用户管理',
        icon: 'ums-admin'
      }
    }]
  },

  {
    path: '/cms',
    component: Layout,
    redirect: '/cms/channel',
    name: 'cms',
    meta: {
      title: '专属日历',
      icon: 'ums'
    },
    children: [
      {
        path: 'channelRole',
        name: 'channelRole',
        component: () => import('@/views/cms/channelRole/index'),
        meta: {
          title: '作者列表',
          icon: 'order'
        }
      },
      {
        path: 'channel',
        name: 'channel',
        component: () => import('@/views/cms/channel/index'),
        meta: {
          title: '日历列表',
          icon: 'order'
        }
      },
      // {
      //   path: 'review',
      //   name: 'review',
      //   component: () => import('@/views/cms/review/index'),
      //   meta: {
      //     title: '日历审核',
      //     icon: 'product-list'
      //   }
      // },
      {
        path: 'channelCalendar',
        name: 'channelCalendar',
        component: () => import('@/views/cms/channelCalendar/index'),
        meta: {
          title: '文章列表',
          icon: 'order'
        }
      },
      // {
      //   path: 'channelCalendarAudit',
      //   name: 'channelCalendarAudit',
      //   component: () => import('@/views/cms/channelCalendarAudit/index'),
      //   meta: {
      //     title: '文章审核',
      //     icon: 'product-list'
      //   }
      // },
    ]
  },

  {
    path: '/sms',
    component: Layout,
    redirect: '/sms/special',
    name: 'sms',
    meta: {
      title: '专属日程',
      icon: 'ums'
    },
    children: [{
      path: 'special',
      name: 'special',
      component: () => import('@/views/sms/special/index'),
      meta: {
        title: '专属日程',
        icon: 'marker'
      }
    }]
  },

  // {
  //   path:'/oms',
  //   component: Layout,
  //   redirect: '/oms/coupon',
  //   name: 'oms',
  //   meta: {title: '优惠券管理', icon: 'ums'},
  //   children: [
  //     {
  //       path: 'coupon',
  //       name: 'coupon',
  //       component: () => import('@/views/oms/coupon/index'),
  //       meta: {title: '优惠券管理', icon: 'ums-menu'}
  //     }
  //   ]
  // },
  {
    path: '/msm',
    component: Layout,
    redirect: '/msm/cash',
    name: 'msm',
    meta: {
      title: '财务管理',
      icon: 'product-list'
    },
    children: [{
        path: 'order',
        name: 'order',
        component: () => import('@/views/msm/order/index'),
        meta: {
          title: '购买记录',
          icon: 'order'
        }
      }, {
        path: 'cash',
        name: 'cash',
        component: () => import('@/views/config/cash/index'),
        meta: {
          title: '提现配置',
          icon: 'order-setting'
        }
      },
      {
        path: 'cashlist',
        name: 'cashlist',
        component: () => import('@/views/msm/cashlist/index'),
        meta: {
          title: '提现列表',
          icon: 'order'
        }
      }
    ]
  }, {
    path: '/sys',
    component: Layout,
    redirect: '/sys/system',
    name: 'sys',
    meta: {
      title: '系统消息',
      icon: 'sms-ad'
    },
    children: [{
      path: 'system',
      name: 'system',
      component: () => import('@/views/sys/system/index'),
      meta: {
        title: '系统消息',
        icon: 'sms-new'
      }
    }]
  }, {
    path: '/fms',
    component: Layout,
    redirect: '/fms/feedback',
    name: 'fms',
    meta: {
      title: '反馈管理',
      icon: 'product-list'
    },
    children: [{
      path: 'feedback',
      name: 'feedback',
      component: () => import('@/views/fms/feedback/index'),
      meta: {
        title: '反馈管理',
        icon: 'product-list'
      }
    }]
  },
  {
    path: '/config',
    component: Layout,
    redirect: '/config/integral',
    name: 'config',
    meta: {
      title: '平台配置',
      icon: 'ums'
    },
    children: [{
        path: 'integral',
        name: 'integral',
        component: () => import('@/views/config/integral/index'),
        meta: {
          title: '积分任务',
          icon: 'ums-menu'
        }
      },
      // {
      //   path: 'fest',
      //   name: 'fest',
      //   component: () => import('@/views/config/fest/index'),
      //   meta: {
      //     title: '班休管理',
      //     icon: 'ums-menu'
      //   }
      // },
      {
        path: 'label',
        name: 'label',
        component: () => import('@/views/config/label/index'),
        meta: {
          title: '标签管理',
          icon: 'ums-menu'
        }
      },
      {
        path: 'itime',
        name: 'itime',
        component: () => import('@/views/config/itime/index'),
        meta: {
          title: '日程提醒',
          icon: 'ums-menu'
        }
      },
      {
        path: 'ttime',
        name: 'ttime',
        component: () => import('@/views/config/ttime/index'),
        meta: {
          title: '任务提醒',
          icon: 'ums-menu'
        }
      },
      {
        path: 'other',
        name: 'other',
        component: () => import('@/views/config/other/index'),
        meta: {
          title: '协议管理',
          icon: 'ums-menu'
        }
      },
      {
        path: 'weather',
        name: 'weather',
        component: () => import('@/views/config/weather/index'),
        meta: {
          title: '天气类型',
          icon: 'ums-menu'
        }
      },

    ]
  }, 
  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: {
      title: '系统管理',
      icon: 'ums'
    },
    children: [{
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: {
          title: '用户列表',
          icon: 'ums-admin'
        }
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: {
          title: '角色列表',
          icon: 'ums-role'
        }
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: {
          title: '分配菜单'
        },
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: {
          title: '分配资源'
        },
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: {
          title: '菜单列表',
          icon: 'ums-menu'
        }
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: {
          title: '添加菜单'
        },
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: {
          title: '修改菜单'
        },
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: {
          title: '资源列表',
          icon: 'ums-resource'
        }
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: {
          title: '资源分类'
        },
        hidden: true
      }
    ]
  },
  // },  {
  //   path:'/inf',
  //   component: Layout,
  //   redirect: '/inf/det',
  //   name: 'inf',
  //   meta: {title: '基本信息', icon: 'ums'},
  //   children: [
  //     {
  //       path: 'det',
  //       name: 'det',
  //       component: () => import('@/views/inf/det/index'),
  //       meta: {title: '信息详情', icon: 'ums-admin'}
  //     }


  //   ]
  // },
  {
    path: '/giv',
    component: Layout,
    redirect: '/giv/giving',
    name: 'giv',
    meta: {
      title: '赠送',
      icon: 'ums'
    },
    children: [{
        path: 'giving',
        name: 'giving',
        component: () => import('@/views/giv/giving/index'),
        meta: {
          title: '赠送',
          icon: 'ums-admin'
        }
      }


    ]
  }, ,
  {
    path: '/version',
    component: Layout,
    redirect: '/version/control',
    name: 'version',
    meta: {
      title: '版本管理',
      icon: 'ums-menu'
    },
    children: [{
      path: 'control',
      name: 'control',
      component: () => import('@/views/version/control/index'),
      meta: {
        title: '版本控制',
        icon: 'ums-menu'
      }
    }]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js